import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 4v3m-4 -3v6m8 -6v6","key":"svg-0"}],["path",{"d":"M12 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5l-3 -1.5","key":"svg-1"}]]

const IconMedal = createReactComponent('outline', 'medal', 'Medal', __iconNode);

export default IconMedal;